import createDuck from '../../../lib/ducks/remoteDuck'
import State from '../../../lib/api/state'

export default createDuck({
  namespace: 'user',
  store: 'provinceState',
  fetchCallback: (options) => State.getState(options),
})
